// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Xg39","left":"styles_left__1bKEH"};